import React, { useState, useEffect } from "react";
import "./portfolio.css";
import { Octokit } from "octokit";
import IMG1 from "../../assets/portfolio1.png";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper/core";
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation]);

const octokit = new Octokit({
  auth: process.env.REACT_APP_GITHUB,
});

async function fetchRepos() {
  const { data } = await octokit.request("GET /users/{username}/repos", {
    username: "aliammari1",
    per_page: 30,
    type: "owner",
    fork: false,
    headers: {
      "X-GitHub-Api-Version": "2022-11-28",
    },
  });

  const filteredRepos = data.filter(
    (repo) =>
      repo.name !== "aliammari1" &&
      repo.name !== "ChatGPT-API-test" &&
      repo.name !== "symfony_atelier3" &&
      repo.name !== "" &&
      !repo.fork
  );
  console.log(data);
  const reposWithLanguages = await Promise.all(
    filteredRepos.map(async (repo) => {
      const { data: languages } = await octokit.request(
        `GET /repos/:owner/:repo/languages`,
        {
          owner: "aliammari1",
          repo: repo.name,
        }
      );
      return {
        ...repo,
        languages: Object.keys(languages),
      };
    })
  );

  const reposWithPages = await Promise.all(
    filteredRepos
      .filter((repo) => repo.has_pages === true)
      .map(async (repo) => {
        const { data: pages } = await octokit.request(
          `GET /repos/:owner/:repo/pages`,
          {
            owner: "aliammari1",
            repo: repo.name,
          }
        );
        return {
          ...repo,
          pages,
        };
      })
  );
  const mergedRepos = reposWithPages.concat(reposWithLanguages);

  const UniqueRepos = mergedRepos.filter((repo, index, self) => {
    return index === self.findIndex((r) => r.name === repo.name);
  });

  return UniqueRepos;
}

function Portfolio() {
  const [repos, setRepos] = useState([]);

  useEffect(() => {
    fetchRepos().then((data) => {
      console.log(data);
      setRepos(data);
    });
  }, []);

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <Swiper
        className="container portfolio__container"
        spaceBetween={40}
        navigation={true}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        {repos.map(
          ({ id, name, languages, html_url, pages, has_pages }, index) => (
            <SwiperSlide key={index}>
              <article key={id} className="portfolio__item">
                <div className="portfolio__item-image">
                  <img src={IMG1} alt={name} />
                </div>
                <h3>{name}</h3>
                <h5
                  style={{ position: "relative", top: -24 + "px" }}
                  className="text-light"
                >
                  {languages?.join(", ")}
                </h5>
                <div className="portfolio__item-cta">
                  <a
                    href={html_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    View on GitHub
                  </a>
                  {has_pages && (
                    <a
                      href={pages?.html_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      Live Preview
                    </a>
                  )}
                </div>
              </article>
            </SwiperSlide>
          )
        )}
      </Swiper>
    </section>
  );
}

export default Portfolio;
